module.exports = __webpack_public_path__ + "img/icon16.f2c3bfaa.png";